(ns dre.components.flash.views
  (:require
   [applied-science.js-interop :as j]
   [dre.components.tooltip :refer [tooltip-wrapper]]
    [dre.components.flash.events :as-alias flash]
    [dre.i18n.events :as-alias i18n]
    [dre.i18n.views :refer [tr]]
    [dre.utils.bem :as bem]
    [re-frame.core :as rf]))


(def component-name :flash-messages)


(defn view
  []
  (when-let [messages @(rf/subscribe [::flash/messages])]
    [:div {:class component-name}
     (doall
       (for [{:keys [id content severity]} messages]
         ^{:key id}
         [:div
          {:class (bem/bem component-name :message severity)}
          [tooltip-wrapper "Dismiss" [:a {:href "#"
                                          :class [(bem/bm :button :bare)
                                                  (bem/be component-name :dismiss)] 
                                          :on-click #(rf/dispatch [::flash/dismiss id])}
                            "\u2715"]]
          content
          (when (= severity :error)
            [:span 
             [:br]
             [:a
              {:on-click #(j/call-in js/window [:Usersnap :open])}
              [tr "Report error"]]])]))]))
